export enum Modes {
  EDIT = 'edit',
  READ = 'read',
  CHANGED = 'changed'
}
